import Spinner from "@/components/ui/spinner";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import React from "react";

interface Props {
  label: string;
  className?: string;
}
const InlineLoader: React.FC<Props> = ({ label, className }) => {
  return (
    <div className={cn("flex items-center justify-center gap-2 p-2", className)}>
      <Spinner size="5" />
      <Text variant="bodySecondary" as="span">
        {label}
      </Text>
    </div>
  );
};

export default InlineLoader;
